const { getConfigFor } = require('./configService')
const { SPLIT_FEATURES } = require('./constants')

/**
 * Get the correct persona API path based on the FE_DYNAMICS_PERSONA_API_MIGRATION feature flag
 * @param {string} endpoint - The API endpoint (e.g., '/user/profile', '/user-metadata/test')
 * @param {string} baseUrl - The base URL for the API (defaults to AUTH0_IDENTITY_API from config)
 * @returns {string} The complete API URL
 */
const getPersonaApiPath = (endpoint, baseUrl = null) => {
  const configResult = getConfigFor(
    SPLIT_FEATURES.FE_DYNAMICS_PERSONA_API_MIGRATION
  )

  const { isEnabled } = configResult
  const basePath = isEnabled ? '/mypersona' : '/sdk'

  // If baseUrl is provided, use it; otherwise, we'll need to get it from config
  if (baseUrl) {
    return `${baseUrl}${basePath}${endpoint}`
  }

  // For client-side usage, we'll need to get the base URL from next/config
  if (typeof window !== 'undefined') {
    const getConfig = require('next/config').default
    const {
      publicRuntimeConfig: { AUTH0_IDENTITY_API },
    } = getConfig()
    return `${AUTH0_IDENTITY_API}${basePath}${endpoint}`
  }

  // For server-side usage, use process.env
  return `${process.env.AUTH0_IDENTITY_API}${basePath}${endpoint}`
}

module.exports = {
  getPersonaApiPath,
}
